export const CREATE_NEW_ROLE = 'CREATE_NEW_ROLE'
export const GET_ROLE = 'GET_ROLE'
export const GET_ALL_ROLES = 'GET_ALL_ROLES'
export const RESET_ROLE = 'RESET_ROLE'
export const GET_ALL_PARENT_ROLES = 'GET_ALL_PARENT_ROLES'
export const DELETE_ROLE = 'DELETE_ROLE'
export const GET_ROLES_FOR_SELECT = 'GET_ROLES_FOR_SELECT'
